// Curated-program training phases. Ranges are explicit so they match the program artwork.

const PHASE_BLOCKS = {
  'muscle-max': [
    { label: 'Build Your Foundation', from: 1, to: 4 },
    { label: 'Build Strength', from: 5, to: 8 },
    { label: 'Maximise Your Progress', from: 9, to: 16 },
  ],
};

/** 'Muscle Max Program' -> 'muscle-max' (same slug the carousel uses). */
export const programSlug = (name = '') =>
  name.toLowerCase().replace(/\bprogram\b/g, '').trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

/**
 * Phase a user is in, or null when the program has no phases defined.
 * @returns {{index:number,total:number,label:string,from:number,to:number,pct:number}|null}
 */
export const programPhase = (programName, week, durationWeeks) => {
  const blocks = PHASE_BLOCKS[programSlug(programName)];
  if (!blocks) return null;

  const last = blocks[blocks.length - 1].to;
  const current = Math.min(Math.max(week || 1, 1), durationWeeks || last);
  const i = blocks.findIndex((b) => current <= b.to);
  const index = i === -1 ? blocks.length : i + 1;
  const block = blocks[index - 1];

  return {
    index,
    total: blocks.length,
    label: block.label,
    from: block.from,
    to: block.to,
    pct: Math.round(((current - block.from + 1) / (block.to - block.from + 1)) * 100),
  };
};
